import React, { useEffect, useState } from "react";

import { Link } from 'react-router-dom';
import AuthUser from "../services/AuthUser";
import AgentLoginModal from "./User/AgentLoginModal";
import Bookservice from "./User/Bookservice";





function Footer() {
   const { token, logout } = AuthUser();


   const logoutUser = () => {

      if (token != undefined) {
         logout();
      }
   }

   const [isAuthenticated, setIsAuthenticated] = useState(false);

   // Check login state on page load
   useEffect(() => {
      const token = localStorage.getItem("agent_token");
      setIsAuthenticated(!!token); // Convert token to boolean
   }, []);


   const logoutAgent = () => {
      localStorage.removeItem("agent_token"); // Remove token
      localStorage.removeItem("agent"); // Remove token
      setIsAuthenticated(false); // Update UI without reload
   };


   return (
      <>
         <footer className="footer-area footer-area10 padding-top footer-4">
            <div className="container">
               <div className="row">
                  <div className="col-lg-4 col-sm-6">
                     <div className="single-footer mr50">

                        <a href="/" className="footer-logo">
                           <img src="assets/img/logo/footer-logo10a.png" width="90%" height="100%" alt="" />
                        </a>
<div className="space20"></div>
                        <p>Vedi Legal Advice Pvt. Ltd.</p>
                        
                        <p>Get started with income tax e-filing today, guided by our expert tax professionals for a smooth and
                           hassle-free experience.</p>
                        <div className="space10"></div>
                        <div className="social social3">
                           <ul>

                              <li><a data-bs-toggle="tooltip" title="Facebook" href="#">
                                 <img src="assets/img/Socialicons/fb.png" className="socialicon" />
                              </a></li>
                              <li><a data-bs-toggle="tooltip" title="Instagram" href="#">
                                 <img src="assets/img/Socialicons/insta.png" className="socialicon" />
                              </a></li>
                              <li><a data-bs-toggle="tooltip" title="Linked in" href="#">
                                 <img src="assets/img/Socialicons/linkedin.png" className="socialicon" />
                              </a>
                              </li>
                              <li>
                                 <a data-bs-toggle="tooltip" title="Twitter" href="#">
                                    <img src="assets/img/Socialicons/twitter.png" className="socialicon" />
                                 </a>
                              </li>
                           </ul>
                        </div>
                        <div className="space10"></div>
                     </div>
                  </div>
                  <div className="col-lg col-sm-6">
                     <div className="single-footer">
                        <h3>Quick Link</h3>
                        <div className="footer-menu">
                           <ul>
                              <li>
                                 <Link to="/">
                                    Home
                                 </Link>

                              </li>
                              <li>


                                 <Link to="/aboutcompany">
                                    About Us
                                 </Link>
                              </li>
                              <li>

                                 <Link to="/services">
                                    Services
                                 </Link>

                              </li>
                              <li>

                                 <Link to="/contactus">
                                    Contact Us
                                 </Link>
                              </li>
                              {/* <li>
                                 {!isAuthenticated ? (
                                    <Link to="#" data-bs-toggle="modal" data-bs-target="#agentLoginModal">
                                       Agent Login
                                    </Link>
                                 ) : (
                                 
                                       <Link to="#" data-bs-toggle="modal" data-bs-target="#agentMenuModal">
                                          Agent Menu
                                       </Link>
                               

                                 )}
                              </li> */}
                              <li>

                                 <span role="button" className="f-logout" onClick={logoutUser}>Logout</span>
                              </li>

                           </ul>
                        </div>
                     </div>
                  </div>
                  {/* <div className="modal fade" id="agentMenuModal" tabIndex="-1" aria-hidden="true">
                     <div className="modal-dialog">
                        <div className="modal-content">
                           <div className="modal-header">
                              <h5 className="modal-title">Agent Menu</h5>
                              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                           </div>
                           <div className="modal-body">
                              <ul className="list-group">
                                 <li className="list-group-item">
                                    <Link to="#" className="text-decoration-none" data-bs-toggle="modal" data-bs-target="#bookServiceModal">
                                       Book Service
                                    </Link>
                                 </li>
                                 <li className="list-group-item text-danger" role="button" onClick={logoutAgent}>
                                    Logout
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
                  <AgentLoginModal setIsAuthenticated={setIsAuthenticated} />
                  <Bookservice /> */}


                  <div className="col-lg col-sm-6">
                     <div className="single-footer">
                        <h3>Our Company</h3>
                        <div className="footer-menu">
                           <ul>

                              <li><Link to="/termsandconditions">Terms And Conditions</Link></li>
                              <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                              <li><Link to="/cookiepolicy">Cookie Policy</Link></li>
                              <li><Link to="/refundpolicy">Refund Policy</Link></li>

                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-3 col-sm-6">
                     <div className="single-footer">
                        <h3>Get in touch</h3>
                        <div className="footer-contact">
                           <div className="single-contact">
                              <div className="contact-icon">
                                 <img src="assets/img/icons/footer10-icon1.png" alt="" />
                              </div>
                              <a href="tel:+918370099299">Line 1: +91 83700-99299</a>
                              <a href="tel:+918370099599">Line 2: +91 83700-99599</a>
                           </div>
                        </div>
                        <div className="footer-contact">
                           <div className="single-contact">
                              <div className="contact-icon">
                                 <img src="assets/img/icons/footer10-icon2.png" alt="" />
                              </div>
                              <a href="mailto:Info@consultia.co">accounts@Dm2Legal.com</a>

                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row align-items-center copyright2">
                  <div className="col-lg-6 m-auto text-center">
                     <p>© 2025 Dm2Legal All Rights Reserved.</p>
                  </div>
               </div>
            </div>
         </footer>


      </>
   );
}
export default Footer;